import { render, staticRenderFns } from "./Resumos.vue?vue&type=template&id=18e4004a&scoped=true"
import script from "./Resumos.vue?vue&type=script&lang=js"
export * from "./Resumos.vue?vue&type=script&lang=js"
import style0 from "./Resumos.vue?vue&type=style&index=0&id=18e4004a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4004a",
  null
  
)

export default component.exports